(ns frontend.view.settings.sys-admin.zadmin.analytics.view
  (:require [common.localization :as loc]
            [reagent.core :as r]
            [frontend.view.reports.events :as events]))

(def headers [:zadmin.analytics/dimension
              :zadmin.analytics/aggregate])

(defn table-header [header]
  [:th (loc/tr header)])

(defn table-row [{:keys [dimension aggregate textual-aggregate]}]
  [:tr 
   {:class "*:whitespace-nowrap *:px-2 *:py-3 *:text-sm *:text-base-light-text even:bg-base-regular"}
   [:td (loc/tr dimension)]
   [:td (if (some? aggregate)
          aggregate
          (loc/tr textual-aggregate))]])

(defn header-key [v]
  (str "zadmin-analytics-table-header-" (if (keyword? v)
                                          (name v)
                                          (str v))))

(defn table-row-key [{:keys [dimension]}]
  (str "zadmin-analytics-table-item-" (if (keyword? dimension)
                                        (name dimension)
                                        (str dimension))))

(defn render [id]
  (let [data (events/get-data! :zadmin-analytics {:tenant-id id})]
    [:div 
     {:class "border border-solid border-base-light-border-paler rounded"}
     [:div
      {:class "p-3 flex justify-between items-center border-b border-solid border-base-light-border-paler"}
      [:h2
       {:class "font-bold"}
       (loc/tr :zadmin-analytics/card-header)]]
     [:div
      {:class "p-4 w-full"}
      [:table 
       {:class-name "min-w-full divide-y divide-solid divide-base-regular-border-paler"}
       [:thead
        [:tr
         {:class "*:py-3 *:px-2 *:text-left *:text-sm *:font-bold *:text-base-light-text"}
         (for [item headers]
           ^{:key (header-key item)}
           [table-header item])]]
       [:tbody
        (for [item data]
          ^{:key (table-row-key item)}
          [table-row item])]]]]))

(defn view [{:keys [db/id]}]
  (r/create-class
   {:component-did-mount    (partial events/fetch-data! [:zadmin-analytics {:tenant-id id}])
    :component-will-unmount (partial events/delete-data! [:zadmin-analytics {:tenant-id id}])
    :reagent-render         (partial render id)}))
